$ = require 'jquery'
ApiAjax = require 'network/api-ajax'
Auth = require 'db/auth'
Controller = require 'controller'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class RemoveOrDeactivateOrgMemberView extends View
  viewTitleKey: ->
    if @org.isPremium()
      'remove or deactivate member'
    else
      'remove member'

  initialize: ->
    @org = @options.org
    @onRemoveSuccess = @options.onRemoveSuccess

  events:
    'click .js-deactivate': 'deactivateMember'
    'click .js-soft-remove': 'removeMember'

  render: ->
    memberType = @org.getMemberType(@model)

    data = @model.toJSON()
    data.orgMemberType = l(['member types', memberType])
    data.ownsOrg = @org.owned()
    data.orgIsBC = @org.isPremium()
    data.isDeactivated = memberType == 'deactivated'
    data.isOrgMember = memberType != 'public'
    data.isVirtual = memberType == 'virtual'
    data.canDeactivate = @org.isPremOrgAdmin(Auth.me()) && !data.isVirtual and !data.isDeactivated
    data.isMe = Auth.isMe(@model)

    @$el.html templates.fill('org_remove_or_deactivate_member', data)

    @

  _checkIfLostVisibility: ->
    if Auth.isMe(@model)
      # We just removed/deactivated ourselves from the org, so just go home
      Controller.navigate '/', { trigger: true }

  deactivateMember: (e) ->
    Util.stop(e)
    @org.deactivateMember(@model)
    @_checkIfLostVisibility()
    PopOver.hide()

    return

  removeMember: (e) ->
    Util.stop(e)

    if $(@el).find('#hardRemove').is(':checked') || @org.getMemberType(@model) == 'deactivated'
      removeType = "Hard Remove"
      @org.memberList.remove(@model, { mass: true, success: @onRemoveSuccess })
    else
      removeType = "Soft Remove"
      @org.memberList.remove(@model, { success: @onRemoveSuccess })

    track("Organization", "Remove Member From Organization", removeType)

    PopOver.hide()

    @_checkIfLostVisibility()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/remove-or-deactivate-org-member-view.coffee